
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.705 18.74c.404.45.482.943.235 1.482L28.768 59.159c-.292.56-.763.842-1.414.842-.09 0-.247-.022-.47-.068a1.433 1.433 0 01-.859-.64 1.279 1.279 0 01-.152-1.01l6.63-27.19L18.84 34.49c-.09.023-.225.034-.404.034a1.56 1.56 0 01-1.044-.37c-.403-.338-.549-.775-.437-1.314l6.764-27.764a1.44 1.44 0 01.538-.774 1.53 1.53 0 01.943-.303h11.038c.426 0 .786.141 1.077.421.292.28.439.612.439.993 0 .18-.057.382-.169.605L31.83 21.601l13.326-3.298c.18-.045.314-.068.405-.068.426 0 .808.169 1.144.506z","fill-rule":"nonzero"}})])
          )
        }
      }
    